export default "__VITE_ASSET__DzaKGjuN__";